import { camelCase } from 'lodash';
import { Dispatch } from 'redux';
import FeatureFlagsController from '../controllers/FeatureFlags';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

// Note: we already have a different set of feature flags.
// The other set is currently targeting company-level feature flags.
// But new requirements create a need to see available feature per FB-page level.
// And the solution hides some of the complexity of the business logic related to
// billing plans having certain features till certain dates. We the approach with
// the features we can have FE relatively dumb, just getting the list, while BE
// will be deciding which features are available to which plan/fb_page
// It feel like we might want to consolidate all feature flags together at a certain
// moment, but currently the time available allows only for small steps forward instead
// of full consolidation effort

class FeatureFlagsCRUDActions extends CrudActionContainer {
  resetAction: string;
  retrieveFeaturesForPlansAction: string;
  retrievedFeaturesForPlansAction: string;

  constructor() {
    super('FEATURE_FLAGS');
    this.retrieveFeaturesForPlansAction = super.makeActionKey(
      'RETRIEVE_FEATURES_FOR_PLANS',
    );
    this.retrievedFeaturesForPlansAction = super.makeActionKey(
      'RETRIEVED_FEATURES_FOR_PLANS',
    );
  }

  retrieveSubscriptionFeatures(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.retrieveAction));
        const res = await FeatureFlagsController.getSubscriptionFeatures(
          facebookPageId,
        );
        const features = (res?.availableFeatures || []).map(f => camelCase(f));
        dispatch(this.retrieved(features));
        return features;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  retrieveFeaturesForPlans(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.retrieveFeaturesForPlansAction));
        const res = await FeatureFlagsController.getFeaturesForPlans(
          facebookPageId,
        );
        const upgradeList = res?.upgradeList;
        dispatch({
          type: this.retrievedFeaturesForPlansAction,
          featuresForPlans: upgradeList,
        });
        return upgradeList;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }
}

export const featureFlagsCRUDActions = new FeatureFlagsCRUDActions();

export const useFeatureFlagsCRUDActions = getActionHookBuilder(
  featureFlagsCRUDActions,
  ['retrieveSubscriptionFeatures', 'retrieveFeaturesForPlans'],
);
